const icon = require('vue-svgicon');
icon.register({
    'lens-antiglare': {
        width: 53,
        height: 48,
        viewBox: '0 0 53 48',
        data: `<path pid="0" d="M26.126 18.331c-3.728-3.622-6.03-8.69-6.03-14.331 0 11.046-8.931 20-20.096 20 11.165 0 20.097 8.89 20.097 20 0-5.64 2.301-10.708 6.029-14.331" _stroke="#000" stroke-width="1.2"/><path pid="1" d="M12.059 24c11.164 0 20.096-8.954 20.096-20 0 11.111 8.932 20 20.097 20-11.165 0-20.097 8.89-20.097 20 0-11.11-8.932-20-20.096-20z" _stroke="#000" stroke-width="1.2"/>`,
    },
});
